import { render, staticRenderFns } from "./editor-Image.vue?vue&type=template&id=44993ddf&lang=pug&"
import script from "./editor-Image.vue?vue&type=script&lang=js&"
export * from "./editor-Image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports